/* eslint-disable import/prefer-default-export */
/* globals CSS_CONFIG */

export const useEsi = () => !!CSS_CONFIG.ESIHOST;

export const getEsiHeaderFooterPath = () => {
  const host = CSS_CONFIG.ESIHOST;
  const market = CSS_CONFIG.COUNTRY;
  const language = CSS_CONFIG.LANGUAGE;

  return `https://${host}/${market}/${language}/header-footer/`;
};
